'use strict';

var log = require('../../log/Log').channel('SetupWifiController');
var defaults = require ('../../defaults/Defaults');
var objectToArray = require('./ObjectToArray');
var ShowPasswordExtension = require('./ShowPasswordExtension');

angular.module('inara').controller('SetupWifiController', SetupWifiController);

SetupWifiController.$inject = ['$scope', '$state', '$timeout', '$interval', 
                               '$window', '$ionicModal', 'DeviceService', 'RoomService',
                               'gettextCatalog'];

function SetupWifiController($scope, $state, $timeout, $interval, 
                             $window, $ionicModal, DeviceService, RoomService,
                             gettextCatalog) {
    var vm = this;
    var queryInterval;
    vm.networkConfig = {};
    vm.connectedSSID = null;
    vm.scanning = false;
    vm.connecting = false;

    log.info('initializing');

    angular.extend(vm, new ShowPasswordExtension($timeout));

    $scope.$on('$ionicView.beforeEnter', function() {
        vm.networkList = null;
        vm.connecting = false;
        vm.showPassword = false;
        vm.passwordFocused = false;
        vm.errorMsg = '';
    });

    $scope.$on('$ionicView.enter', function() {
        queryWifiNetworks();
        queryInterval = $interval(queryWifiNetworks, 10000);
    });

    $scope.$on('$stateChangeSuccess', function(event, toState, toParams, 
                                               fromState, fromParams) {
        if (fromState.name === 'setup.wifi') {
            $interval.cancel(queryInterval);
            vm.wifiConnectView.hide();
            vm.wifiInfoView.hide();
        }
    });

    $ionicModal.fromTemplateUrl('setupWifiConnect.html', {
        scope: $scope,
        animation: 'slide-in-up',
        backdropClickToClose: false
    }).then(function(view) {
        vm.wifiConnectView = view;
    });

    $ionicModal.fromTemplateUrl('setupWifiInfo.html', {
        scope: $scope,
        animation: 'slide-in-up',
        backdropClickToClose: false
    }).then(function(view) {
        vm.wifiInfoView = view;
    });

    $scope.$on('modal.shown', function(evt, view) {
        if (view === vm.wifiConnectView) {
            focusLoginField();
        }
    });

    $scope.$on('modal.hidden', function(evt, view) {
        if (view === vm.wifiConnectView) {
            vm.networkConfig.username = '';
            vm.networkConfig.password = '';
            vm.errorMsg = '';
            vm.wifiConnectForm.$setPristine();
            cordova.plugins.Keyboard.close();
        }
    });

    $scope.$on('$destroy', function() {
        vm.wifiConnectView.remove();
        vm.wifiInfoView.remove();
    });

    // TODO: should probably use $ionicView.leave as a cue to 
    // cancel any pending wifi operations (that is, the user
    // likely went back to the network view and doesn't want
    // to wait for the operation to complete.)

    function queryWifiNetworks() {
        log.debug('querying wifi networks');
        vm.scanning = true;
        DeviceService.isWifiEnabled().then(function(enabled) {
            if (enabled) {
                queryCurrentSSID();                
                DeviceService.getWifiNetworks().then(function(networks) {
                   $timeout(function() {
                       vm.scanning = false;
                       vm.networkList = networks;
                       queryCurrentSSID();
                  }, 2000);
                });
            }
            else {
                log.warning('Tried to query wifi networks while wifi disabled');
            }
        });
    }

    function queryCurrentSSID() {
        DeviceService.getCurrentWifiNetwork().then(function(ssid) {
            log.debug('connected SSID = ' + ssid);
            vm.connectedSSID = ssid;
        }).catch(function() {
            log.debug('no connected SSID');
            vm.connectedSSID = null;
        });
    }

    /// Title bar for setup join wifi network page
    vm.getViewTitle = function() { return gettextCatalog.getString('Join Wireless Network'); };

    /// Placeholder indicating that discovered wifi network has no name (SSID)
    vm.getNoSSIDLabel = function() { return gettextCatalog.getString('[No SSID]'); };

    /// Placeholder for wifi username input field
    vm.getUsernamePlaceholder = function() { return gettextCatalog.getString('Username'); };

    /// Placeholder for wifi password input field
    vm.getPasswordPlaceholder = function() { return gettextCatalog.getString('Password'); };

    /// Label for show password checkbox
    vm.getShowPasswordLabel = function() { return gettextCatalog.getString('Show Password'); };

    vm.networkHasUsername = function(network) {
        return false;
    };

    vm.networkHasPassword = function(network) {
        if (!network || !network.capabilities) return false;

        var securityType = vm.getSecurityType(network);
        return securityType.startsWith('WEP') ||
               securityType.startsWith('WPA');
    };

    vm.onNetworkClick = function(network) {
        vm.network = network;
        if (network.SSID === vm.connectedSSID) {
            log.debug('already connected, showing info');
            $timeout(function() {
                vm.wifiInfoView.show();
            }, defaults.inara.setupPageFlipDelay);
        }
        else {
            log.debug('connecting to '  + network.SSID);
            if (angular.isDefined(vm.wifiConnectForm)) {
                vm.wifiConnectForm.$setPristine();                
            }
            $timeout(function() {
                vm.wifiConnectView.show();
            }, defaults.inara.setupPageFlipDelay);
        }
    };

    function focusLoginField() {
        var element = null;
        if (vm.networkHasUsername(vm.network)) {
            element = $window.document.getElementById('username');
        }
        else if (vm.networkHasPassword(vm.network)) {
            element = $window.document.getElementById('password');            
        }
        if (element) {
            element.focus();
            if (element.value.length > 0) {
                element.setSelectionRange(element.value.length, 
                                          element.value.length);
            }
            else {
                element.select();
            }
            cordova.plugins.Keyboard.show();
        }
    }

    vm.getSecurityType = function(network) {
        /// Unknown wifi network security type
        var securityType = gettextCatalog.getString('Unknown');
        if (angular.isDefined(network) &&
            network !== null &&
            network.hasOwnProperty('capabilities')) {
            /// Wifi network security type (open network means no security)
            securityType = gettextCatalog.getString('Open');
            var capabilities = /\[(.*?)\]/g;
            var matches = network.capabilities.match(capabilities);
            for (var i = 0; i < matches.length; i++) {
                var cap = matches[i].toUpperCase();
                if (cap.startsWith('[WPA-PSK')) {
                    securityType = 'WPA PSK';
                } 
                else if (cap.startsWith('[WPA2-PSK')) {
                    securityType = 'WPA2 PSK';
                }
                else if (cap.startsWith('[WEP')) {
                    securityType = 'WEP';
                }
            }
        }
        return securityType;
    };

    vm.getIPAddress = function(network) {
        /// Network information string when device has no IP address
        var ipAddress = gettextCatalog.getString('None');
        var controller = RoomService.getController();

        if (angular.isDefined(controller) && 
            controller !== null &&
            controller.hasOwnProperty('networkInterfaces')) {
            for (var ifName in controller.networkInterfaces) {
                if (!controller.networkInterfaces.hasOwnProperty(ifName)) {
                    continue;
                }
                var iface = angular.copy(controller.networkInterfaces[ifName]);
                if (ifName.startsWith('wlan')) {
                    var linkAddresses = 
                        objectToArray(iface.linkAddresses)
                            .filter(function(el) {
                                // ignore link local addresses
                                return el.address && 
                                    el.family === 'ipv4' && 
                                    !el.address.startsWith('169.254');
                                    // TODO: re-enable IPv6 when we have a better way to display it
                                    //el.family === 'ipv6' && !el.address.startsWith('fe80'));
                            })
                            .map(function(el) {
                                return el.address;
                            });
                    if (linkAddresses.length > 0) {
                        ipAddress = linkAddresses.join(', ');
                    }
                }
            }
        }

        return ipAddress;
    };

    vm.cancel = function($event, modal) {
        modal.hide();
        if ($event.stopPropagation) $event.stopPropagation();
        if ($event.preventDefault) $event.preventDefault();
        $event.returnValue = false;
    };

    vm.forget = function(network) {
        DeviceService.forgetWifiNetwork(network.SSID).then(function() {
            log.debug('forgot: ' + network.SSID);
        }).catch(function() {
            log.error('failed forgetting: ' + network.SSID + '.  Perhaps ' +
                'this network was created outside of Mira Connect Setup?');
        }).finally(function() {
            queryCurrentSSID();
            vm.wifiInfoView.hide();
        });
    };

    vm.join = function() {
        // Configuration for InAppBrowser to check whether wifi connection
        // utilized a captive portal for login.
        // var captiveUrl = 'https://mira.aveosystems.com/captive.html';
        // var browser = null;
        // var browserLoadError = null;

        vm.passwordFocused = false;
        vm.connecting = true;
        vm.errorMsg = '';
        vm.wifiConnectForm.$setPristine();

        function handleJoinError() {
            vm.connecting = false;
            /// Error message when unable to connect to wifi network
            vm.errorMsg = gettextCatalog.getString(
                'Could not connect to {{networkName}}', { networkName: vm.network.SSID });
            vm.passwordFocused = true;
        }

        // function checkForCaptivePortal() {
        //     log.info('Checking for captive portal...');
        //     browser = cordova.InAppBrowser.open(captiveUrl, '_blank', 'hidden=yes,location=yes');
        //     browser.addEventListener('loadstart', onBrowserLoadStart);
        //     browser.addEventListener('loadstop', onBrowserLoadStop);
        //     browser.addEventListener('loaderror', onBrowserLoadError);
        //     browser.addEventListener('exit', onBrowserExit);
        // }

        // function onBrowserLoadStart() {
        //     log.debug('loading captive portal test URL: ' + captiveUrl);
        // }

        // function onBrowserLoadStop() {
        //     if (browserLoadError !== null) {
        //         log.debug('browserLoadError = ' + browserLoadError);
        //         vm.connecting = false;
        //         vm.errorMsg = 'Error while checking for captive portal';
        //         browser.close();
        //         return;
        //     }
        //     log.debug('page load complete, checking for captive portal...');
        //     var checkCaptivePortal = "document.body.innerHTML !== 'Success'";
        //     browser.executeScript({ code: checkCaptivePortal }, onCheckCaptivePortal);
        // }

        // function onCheckCaptivePortal(params) {
        //     if (params[0] === true) {
        //         log.info('Captive portal detected');
        //         browser.show();
        //     }
        //     else {
        //         log.info('No captive portal');
        //         browser.close();
        //     }
        // }

        // function onBrowserLoadError(params) {
        //     log.debug('page load error!');
        //     browserLoadError = params.message;
        // }

        // function onBrowserExit() {
        //     $scope.goTo('setup.login');
        //     cleanUpBrowser();
        // }

        // function cleanUpBrowser() {
        //     if (browser !== null) {
        //         log.debug('cleaning up browser');
        //         browser.removeEventListener('loadstart', onBrowserLoadStart);
        //         browser.removeEventListener('loadstop', onBrowserLoadStop);
        //         browser.removeEventListener('loaderror', onBrowserLoadError);
        //         browser.removeEventListener('exit', onBrowserExit);
        //         browser = null;
        //     }
        // }
        
        // TODO: the chaining here seems overly complicated, but currently
        // works.

        DeviceService.joinWifiNetwork(vm.network, 
                                      vm.networkConfig.username, 
                                      vm.networkConfig.password).then(
            function() {
                var timeoutInSeconds = 30;
                DeviceService.isWifiConnected(timeoutInSeconds).then(
                    function(connected) {
                        if (connected) {
                           log.info('Connected to wifi network: ' + vm.network.SSID);
                           vm.connecting = false;
                           vm.networkConfig.username = '';
                           vm.networkConfig.password = '';
                           queryCurrentSSID();
                           vm.wifiConnectView.hide();
                           $timeout(function() {
                                vm.continue();
                           }, 200);
                           //checkForCaptivePortal();
                        }
                        else {
                            handleJoinError();
                        }
                    },
                    handleJoinError
                );
            },
            handleJoinError);

    };

    vm.canContinue = function() {
        return angular.isDefined(vm.networkList) &&
               vm.networkList !== null &&
               vm.connectedSSID !== null &&
               angular.isDefined(vm.networkList.find(function(el) {
                    return el.SSID === vm.connectedSSID;
               }));
    };

    vm.continue = function() {
        if (!angular.isDefined(vm.networkList) ||
            vm.networkList === null) {
            log.error('vm.networkList = ' + vm.networkList);
            return;
        }
        if (vm.connectedSSID === null) {
            log.error('vm.connectedSSID = ' + vm.connectedSSID);
            return;
        }

        vm.network = vm.networkList.find(function(el) {
            return el.SSID === vm.connectedSSID;
        });
        $scope.setup.network.config = angular.extend({}, vm.network);
        angular.extend($scope.setup.network.config, vm.networkConfig);
        $scope.goTo('setup.pairing');
    };

}

module.exports = SetupWifiController;
